import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CibilReportService } from '../cibil-report/cibil-report.service';
 
@Component({
  selector: 'wl-bre-status-check',
  templateUrl: './brestatuscheck.component.html',
  styles: [],
  providers : [CibilReportService]
})
export class BreStatusCheckComponent implements OnInit {

  status:any;
  constructor(
    private crifReport: CibilReportService,
    private snackbar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.status = "";
    this.crifReport.getBreStatus().subscribe(result=>{
      console.log(result);
      this.status = result == 'success' ? 'success' : 'failure';
    })

  }

}
